export default "__VITE_PUBLIC_ASSET__3a71f07b__"